import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type FbqFn = ((action: string, eventName: string) => void) | undefined;

export default function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    const fbq = (window as Window & { fbq?: FbqFn }).fbq;
    if (typeof fbq === 'function') {
      fbq('track', 'PageView');
    }
  }, [location.pathname, location.search]);

  return null;
}
